enum DeliveryOrderType {
    MONEY_DELIVERY = 'MONEY_DELIVERY',
    ARTICLE_DELIVERY = 'ARTICLE_DELIVERY',
    PACKAGE_DELIVERY = 'PACKAGE_DELIVERY',
    MISCELLANY_ORDER = 'MISCELLANY_ORDER',
    SHOP_ORDER = 'SHOP_ORDER',
}
export default DeliveryOrderType